import Immutable from 'immutable';

export const GET_ORDERS = 'takeback/api/ORDERS';
export const GET_ORDERS_SUCCESS = 'takeback/api/ORDERS_SUCCESS';
export const GET_ORDERS_FAILURE = 'takeback/api/ORDERS_FAILURE';
export const GET_ORDER = 'takeback/api/ORDER';
export const GET_ORDER_SUCCESS = 'takeback/api/ORDER_SUCCESS';
export const GET_ORDER_FAILURE = 'takeback/api/ORDER_FAILURE';


export const FETCH_ORDER_LABEL = 'takeback/api/ORDER_LABEL';
export const FETCH_ORDER_LABEL_STOP = 'takeback/api/ORDER_LABEL_STOP';
export const FETCH_ORDER_LABEL_SUCCESS = 'takeback/api/ORDER_LABEL_SUCCESS';
export const FETCH_ORDER_LABEL_FAILURE = 'takeback/api/ORDER_LABEL_FAILURE';

const initialState = Immutable.OrderedMap();


// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {

    case GET_ORDERS_SUCCESS:
        return state.mergeDeep(action.orders.reduce((map, order) => {
            return map.set(order.get('id'), order);
        }, Immutable.OrderedMap()));

    case GET_ORDER_SUCCESS:
        return state.set(action.order.get('id'), action.order);

    case FETCH_ORDER_LABEL_SUCCESS:
    case FETCH_ORDER_LABEL_STOP:
    case FETCH_ORDER_LABEL_FAILURE:
        return state
            .set(action.orderId,
                state.get(action.orderId).set('labelStatus', action.payload)
            );

    default:
        return state;

    }
}

// Selectors
export function selectOrders(state) {
    return state.orders;
}

export function selectOrderByCode(state, code) {
    return state.orders.find(order => ((order.get('code') === code) && order.get('id')));
}


// Actions
export function getOrders() {
    return {type: GET_ORDERS};
}

export function getOrdersSuccess(orders) {
    return {type: GET_ORDERS_SUCCESS, orders};
}

export function getOrdersFailure(error) {
    return {type: GET_ORDERS_FAILURE, error};
}

export function getOrder(params, options = {}) {
    return Object.assign({type: GET_ORDER, params}, options);
}

export function getOrderSuccess(order) {
    return {type: GET_ORDER_SUCCESS, order};
}

export function getOrderFailure(error) {
    return {type: GET_ORDER_FAILURE, error};
}

export function fetchOrderLabel(orderId) {
    return {type: FETCH_ORDER_LABEL, orderId};
}

export function fetchOrderLabelSuccess(orderId, payload) {
    return {type: FETCH_ORDER_LABEL_SUCCESS, orderId, payload};
}

export function fetchOrderLabelFailure(orderId, payload = null) {
    return {type: FETCH_ORDER_LABEL_FAILURE, orderId, payload};
}

